import SaaConsumeIndex from "components/templates/common/SAA/consume/Index";

export default function SaaConsumeSurvey({
  isMobile,
  surveyList,
}: {
  isMobile: boolean;
  surveyList: any;
}) {
  return (
    <main
      className="min-w-[360px] max-w-[800px] w-screen bg-bg "
      style={{
        minHeight: isMobile ? "100dvh" : "calc(100vh - 80px)",
      }}
    >
      <SaaConsumeIndex surveyList={surveyList} isMobile={isMobile} />
    </main>
  );
}
